import {
  formatTzDate,
  parseLocalDatetimeStringToZonedDate,
} from 'Data/format.js'
import { addMinutes } from 'date-fns'

export function formatTime(booking) {
  let timeZoneId = booking.location.time_zone_id
  let startTime = parseLocalDatetimeStringToZonedDate(
    `${booking.local_start_date}T${booking.local_start_time}`,
    timeZoneId
  )
  let endTime = addMinutes(startTime, booking.duration)
  return `${formatTzDate(
    startTime,
    'MMM dd, yyyy, hh:mm',
    timeZoneId
  )} - ${formatTzDate(endTime, 'hh:mmaa', timeZoneId)}`
}
